import * as React from 'react';
import { useContext, useEffect, useState } from 'react';

import { OneTimeProductContext } from '.';
import { InlineSpinner } from '../../assets/Spinner';
import { formatingOptions } from '../../formatingOptions';
import { OneTimeModalType, Option } from '../../pages/types';
import { filterProductsByPetMealType } from '../../utils';
import { Dropdown } from '../Dropdown';
import { MultiSelectDropdown } from '../MultiSelectDropdown';
import { Button } from '../buttons/Button';

export const OneTimeProductStep1 = () => {
  const {
    dogs,
    order,
    setSelectedDog,
    fullProducts,
    selectedProducts,
    setSelectedProducts,
    isLoading,
    isEverythingSelected,
    navigateBetweenSteps,
    selectedDog,
  } = useContext(OneTimeProductContext);
  const formattedProducts = formatingOptions(fullProducts, { value: 'id', label: 'code' });
  const [filteredOptions, setFilteredOptions] = useState(formattedProducts);

  useEffect(() => {
    if (!filteredOptions?.length && fullProducts?.length) {
      setFilteredOptions(formattedProducts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formattedProducts?.length]);

  const handleSelectDog = (newSelection: Option) => {
    setSelectedDog(newSelection);
    const productsForPet = order.products.filter(
      (product) => product.pet_plan?.pet_name === newSelection.label
    );
    const formattedProductsForPet = formatingOptions(productsForPet, {
      value: 'id',
      label: 'code',
    });
    setSelectedProducts([]);
    setFilteredOptions(
      filterProductsByPetMealType(
        fullProducts,
        OneTimeModalType.ONE_TIME_PRODUCT,
        formattedProductsForPet
      )
    );
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full pr-2 pt-3 flex flex-col gap-2">
        <div className="text-md font-semibold text-left">
          <h3>Which dog would you like to add a one-time product for?</h3>
        </div>
        <div className="mb-2 max-w-[80%]">
          <Dropdown
            options={dogs}
            selectedOption={selectedDog || { value: '', label: 'Select dog' }}
            setSelectedOption={handleSelectDog}
          />
        </div>
      </div>
      {selectedDog ? (
        <div className="w-full pr-2 flex flex-col gap-2">
          <div className="text-md font-semibold text-left">
            <h3>Which one-time product should we include in this dog's next Order?</h3>
          </div>
          <div className="mb-2 flex relative max-w-[80%]">
            <MultiSelectDropdown
              options={filteredOptions}
              selectedOptions={selectedProducts}
              setSelectedOptions={setSelectedProducts}
              placeholder="Start typing a product code"
            />
            {isLoading && (
              <div className="absolute inset-0 bg-black/10 flex items-center justify-center">
                <InlineSpinner />
              </div>
            )}
          </div>
        </div>
      ) : null}
      <div className="mt-[45px] w-fill flex justify-center">
        <Button
          isDisabled={!isEverythingSelected}
          label="Continue"
          variant={isEverythingSelected ? 'primary' : 'secondary'}
          onClick={navigateBetweenSteps}
        />
      </div>
    </div>
  );
};
